import { render, staticRenderFns } from "./recurso-acessibilidade-component-listar.vue?vue&type=template&id=2862eab8&"
import script from "./recurso-acessibilidade-component-listar.vue?vue&type=script&lang=ts&"
export * from "./recurso-acessibilidade-component-listar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2862eab8')) {
      api.createRecord('2862eab8', component.options)
    } else {
      api.reload('2862eab8', component.options)
    }
    module.hot.accept("./recurso-acessibilidade-component-listar.vue?vue&type=template&id=2862eab8&", function () {
      api.rerender('2862eab8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/component/recurso-acessibilidade-component-listar.vue"
export default component.exports